var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help",class:[_vm.errorClass]},[(_vm.errorSymbol)?_c('icon',{staticClass:"is-small",attrs:{"icon":_vm.errorSymbol,"type":_vm.iconType}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.errorOutput))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }